import React from 'react';
import { Col, Row } from "react-bootstrap";
import { TextAreaBox } from 'fw/forms';
import { CommentsGrid, ReviewUpload, AdminAppIdHeader } from 'areas/shared/components';
import { SetupTab } from 'areas/shared/pages/setup';
import ReviewPanel from 'areas/admin/certification/shared/ReviewPanel';
import * as App from 'modules/app/App';
import * as API from 'modules/app/API';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { ActionButton, Button } from 'fw/components';
import * as ReportManager from 'modules/reports/ReportManager';
import AdminStepToolbar from 'areas/admin/certification/shared/AdminStepToolbar';
import UploadsConfig from './UploadsConfig';
import { QueueType } from 'areas/shared/consts';

class FinancialDocuments extends SetupTab {
    initialForm() {
        return {
            rowVersion: null,
            reviewComment: '',
            tooltips: []
        }
    }

    skipValidations() {
        return App.hasPrivilege("AdminSkipValidations");
    }

    updatePostData = (form, dirty) => {
        for (var ref in this.refs) {
            this._form.register(this.refs[ref]);
        }
        if (this.state.form.showComplete)
            this.validateReviewStatus(form);
        this.setState({ form });

        if (dirty === true)
            this.dirt();
    }

    validateReviewStatus = (form) => {
        let canComplete=
        (
            this.state.form.certificationQueueTypeCode !== QueueType.APPLICATION_REVIEW.code &&
            this.state.form.certificationQueueTypeCode !== QueueType.CERTIFICATION_REVIEW.code &&
            this.state.form.certificationQueueTypeCode !== QueueType.COMMITTEE_REVIEW.code
        ) ||
        (this.state.form.reviewUploads.every((reviewUpload) => { return reviewUpload.validDocument; })
            && (this.state.form.otherDocuments === null
                || this.state.form.otherDocuments.every((document) => { return document.uploadModel && document.uploadModel.validDocument; })));

        if (form.reviewStatus !== null && form.reviewStatus !== undefined && form.reviewStatus && !canComplete)
            form.reviewStatus = false;
    }

    beforeSave = (cb) => {
        this._ast.checkReviewStatus(cb);
    }

    privileges() {
        return {
            edit: App.hasPrivilege("AdminAppManagementEdit")
        }
    }

    urls() {
        return {
            get: API.Admin.url('/certification/getFinancialDocument'),
            save: API.Admin.url('/certification/saveFinancialDocument'),
        }
    }

    getRequest(selectedId) {
        return {
            certificationKey: selectedId,
            queueTypeCode: this.props.queueTypeCode
        }
    }

    saveRequest() {
        return {
            certificationId: this.state.form.certificationId,
            entityId: this.state.form.savedEntityId,
            otherDocuments: this.state.form.otherDocuments,
            rowVersion: this.state.form.rowVersion,
            reviewUploads: this.state.form.reviewUploads,
            reviewStatus: this.state.form.reviewStatus,
            reviewQueueTypeCode: this.state.form.certificationQueueTypeCode,
            reviewComment: this.state.reviewComment
        }
    }

    isEnabled(data) {
        return !data.isReviewFinished;
    }

    isValidated(data) {
        return data.isSubmitted;
    }

    ready = () => {
        // If currentStep is disabled (fastTrack), then go to tab "Cert."
        const currentStepIndex = this.props.setupProps.tabs.findIndex(tab => tab.key === "financialDocuments");
        if (this.props.setupProps.tabs[currentStepIndex].disabled)
            this.props.handleTabSelect("businessCertification");

        this.focusControl && this.focusControl.focus();
    }

    handleReviewUpload = (formUpload) => {
        let form = this.state.form;
        var items = form.reviewUploads;

        var foundIndex = items.findIndex(x => x.upload.uploadKey === formUpload.upload.uploadKey);
        if (foundIndex === -1) {
            items.push(formUpload);
        }
        else {
            items[foundIndex] = formUpload;
        }

        form["reviewUploads"] = items;

        this.updatePostData(form, true);
    }

    handleDescriptionChange = (value, index) => {
        let form = this.state.form;

        form.otherDocuments[index].documentDescription = value;
        this.updatePostData(form, true)
    };

    handleOtherDocumentRemove = (index) => {
        let form = this.state.form;

        form.otherDocuments[index].documentDescription = "";
    };

    handleUploadOtherDocumentChange = (formUpload, index) => {
        let form = this.state.form;

        form.otherDocuments[index].uploadModel = formUpload;

        this.updatePostData(form, true);
    };

    addOtherDocument = () => {
        let form = this.state.form;
        form.otherDocuments.push({
            financialOtherDocumentId: -Math.abs(Date.now() | 0)
        });

        this.updatePostData(form);
    };

    handleRemoveOtherDocument = (i) => {
        let form = this.state.form;
        form.otherDocuments.splice(i, 1);

        this.updatePostData(form, true);
    }

    handlePrint = () => {
        const rq = Object.assign({
            reportType: "FinancialDocumentInfoReport",
            format: "PDF",
            parameters: {
                CertificationId: this.state.form.certificationId
            }
        });

        ReportManager.execute(rq);
    }

    buildFacilityUploadLabel() {
        let businessPremisesName = this.state.form.businessPremisesName !== null ?
            this.state.form.businessPremisesName.toUpperCase()
            : ""

        if (businessPremisesName === "OWNED")
            return "Security Deeds, Title Deed and Property Taxes";
        else if (businessPremisesName === "HOME-BASED")
            return "Security Deeds, Title Deed, Property Taxes and/or Lease Agreement";
        else // Default or LEASED
            return "Facility Lease or Title";
    }

    renderOtherDocuments = () => {
        var me = this;
        return this.state.form.otherDocuments.map((item, index) => (
            <Row key={item.financialOtherDocumentId} style={{ marginBottom: 10 }}>
                <Col md={12}>
                    <ReviewUpload
                        disabled={!me.state.enabled}
                        reviewUpload={item.uploadModel}
                        reviewDisabled={this.state.form.isRenewal}
                        onChange={formUpload => this.handleUploadOtherDocumentChange(formUpload, index)}
                        notApplicableAvailable={false}
                        queueTypeCode={this.state.form.certificationQueueTypeCode} />
                </Col>
                <Col md={6}>
                    <Row>
                        <Col md={12}>
                            <TextAreaBox
                                value={item.documentDescription}
                                placeholder="Briefly describe your Uploaded Financial Document here..."
                                maxLength={500}
                                onChange={value => this.handleDescriptionChange(value, index)}
                                required
                                ref={`otherFileDescription_${index}`}
                            />
                        </Col>
                    </Row>
                </Col>
                <Col md={1} style={{ marginTop: 5, marginLeft: -15, paddingLeft: 0, textAlign: "left" }}>
					<Button type="button" bsStyle="link" onClick={() => this.handleRemoveOtherDocument(index)} title="Remove Financial Document">
                        <FontAwesomeIcon icon={faTrashAlt} size="lg" color="black" />
					</Button>
                </Col>
            </Row >
        ));
    };

    handleReviewStatus = (formReview) => {
        let form = this.state.form;
        form["reviewStatus"] = formReview.isReviewCompleted;

        this.updatePostData(form, true);
    };

    handleStepCommentSave = (formParam, callback) => {
        let form = this.state.form;

        if (formParam && formParam.comments)
            form.comments = formParam.comments;

        this.updatePostData(form, false);

        if (callback)
            callback();
        else
            this.handleSubmit();
    }

    handleAdminStepToolbar = () => {
        this.handleSubmit();
    }

    handleCommentsGrid = (comments) => {
        this.handleUpdateComments(comments);
    }

    handleCommentChange = (comment) => {
        this.dirt();
        this.setState({
            reviewComment: comment
        });
    }

    handleUpdateComments(comments) {
        let form = {
            ...this.state.form,
            comments
        };
        this.updatePostData(form, false);
    }

    afterSave = (entityId, data) => {
        this.addCommentFromSave(data.reviewComment);
    }

    addCommentFromSave = (comment) =>{
        if (comment === null) 
            return;
           
        let comments = this.state.form.comments;
                
        comments.unshift({
            commentId: comment.commentId,
            reviewTypeDescription: comment.reviewTypeDescription,
            queueTypeDescription: comment.queueTypeDescription,
            content: comment.content,
            addedDate: comment.addedAt,
            addedBy: comment.addedBy,
            commentTypeCode: comment.commentTypeCode
        });

        let form = {
            ...this.state.form,
            comments
        };

        this.updatePostData(form, false);

        // Clean Add Comment textbox
        this._commentsGrid.cleanComment();
        this.setState({ reviewComment: '' });

    }

    renderAdminStepToolbar = () => {
        const disableCancel = !this.state.buttons.cancel;
        //Show cancel
        const showCancel = this.state.showButtons.cancel;
        //Show save 
        const showSave = this.state.showButtons.save && this.state.enabled;
        
        return (
            <AdminStepToolbar
                ref={(c) => { this._ast = c }}
                onCommentSave={this.handleStepCommentSave}
                onSave={this.handleAdminStepToolbar}
                certificationKey={this.props.selectedId}
                reviewTypeCode={'FIN'}
                queueTypeCode={this.state.form.certificationQueueTypeCode}
                reviewStatus={this.state.form.reviewStatus}
                comments={this.state.form.comments}
                showCancel={(showCancel && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                showSave={(showSave && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                onCancel={this.handleCancel}
                disableCancel={disableCancel}
                setupProps={this.props.setupProps}
                handleTabSelect={this.props.handleTabSelect}
            />)
    }

    renderButtons = () => {
        return (
            <React.Fragment>
                <hr />
                <Row>
                    <Col md={6}>
                    </Col>
                    <Col md={6}>
                        {this.renderAdminStepToolbar()}
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    renderUploadFields = () => {
        var me = this;
        return this.state.form.reviewUploads.map((item, index) => (
            me.renderUploadField(item)
        ));
    }

    renderUploadField = (reviewUpload) => {
        var me = this;
        const uploadKey = reviewUpload.upload.uploadKey;

        return (
            <ReviewUpload
                disabled={!me.state.enabled}
                key={uploadKey}
                reviewUpload={reviewUpload}
                reviewDisabled={this.state.form.isRenewal}
                config={UploadsConfig}
                onChange={this.handleReviewUpload}
                queueTypeCode={this.state.form.certificationQueueTypeCode}
                tip={me.setTip(UploadsConfig[uploadKey].tooltipCode)}/>
        );
    }

    renderForm() {
        let me = this;

        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={12}>
                                <h3 style={{ marginTop: "0px", position: "relative" }}>
                                    <AdminAppIdHeader appId={this.state.form.certificationId} daysOpen={this.props.setupProps.daysOpen} certificationType={this.state.form.certificationType} certificationStatus={this.state.form.certificationStatus} />
                                </h3>
                                <hr />
                                <h3 style={{ marginTop: "0px" }}>
                                    Financial Documents – <small> Please submit all required Financial Documents</small>
                                    {this.renderAdminStepToolbar()}
                                    {this.state.form.allowPrinting && <div className="pull-right"><ActionButton id="btnPrint" onClick={this.handlePrint} icon="print" bsSize="sm">Print</ActionButton></div>}
                                </h3>
                                <hr />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={10}>
                                {me.renderUploadFields()}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={10}>
                                <label>&nbsp;</label>
                                {this.state.form.otherDocuments != null &&
                                    this.state.form.otherDocuments.length > 0 && (
                                        <React.Fragment>{this.renderOtherDocuments()}</React.Fragment>
                                    )}
                                {this.state.enabled && (this.state.form.otherDocuments == null || this.state.form.otherDocuments.length < 5) &&
									<Button type="button" bsStyle="link" onClick={this.addOtherDocument}>
                                        Add another Financial Document
									</Button>
								}
                            </Col>
                        </Row>
                    </Col>
                </Row>
                {this.state.form.showReview ?
                    <React.Fragment>
                        <Row>
                            <CommentsGrid
                                ref={(c) => { this._commentsGrid = c }}
                                comments={this.state.form.comments}
                                documents={this.state.form.reviewDocuments}
                                certificationKey={this.props.selectedId}
                                reviewTypeCode={"FIN"}
                                queueTypeCode={this.state.form.certificationQueueTypeCode}
                                enableExport={true}
                                entityId={this.state.form.savedEntityId}
                                readonly={!this.state.privileges.edit || !this.state.enabled}
                                onSave={this.handleCommentsGrid}
                                onCommentChange={this.handleCommentChange} />
                        </Row>
                        {this.state.form.showComplete ?
                            <Row>
                                <ReviewPanel stepName="Financial Document"
                                    canComplete={
                                        (
                                            this.state.form.certificationQueueTypeCode !== QueueType.APPLICATION_REVIEW.code &&
                                            this.state.form.certificationQueueTypeCode !== QueueType.CERTIFICATION_REVIEW.code &&
                                            this.state.form.certificationQueueTypeCode !== QueueType.COMMITTEE_REVIEW.code
                                        ) ||
                                        (this.state.form.reviewUploads.every((reviewUpload) => { return reviewUpload.validDocument; })
                                            && (this.state.form.otherDocuments === null
                                                || this.state.form.otherDocuments.every((document) => { return document.uploadModel && document.uploadModel.validDocument; })))}
                                    onChange={this.handleReviewStatus}
                                    reviewStatus={this.state.form.reviewStatus} />
                            </Row>
                            : null}
                    </React.Fragment> 
                    : null}
            </React.Fragment>
        )
    }
}

export default FinancialDocuments; 



// WEBPACK FOOTER //
// ./src/areas/admin/certification/certificationInfo/financialDocuments/FinancialDocuments.js